<script setup lang="ts">
import {Slider} from "@/Components/Library";
import {Question} from "@/Types/question";

const props = defineProps<{
    question: Question;
}>();

const model = defineModel();
</script>
<template>
    <div>
        <h3 class="mb-6">Drag the slider until you reach the desired result</h3>
        <div class="mb-4 flex items-center p-2 pr-10">
            <span v-if="!question.params.slider_range" class="text--center block w-12 text-lg font-bold">
                {{ model ?? 0 }}
            </span>
            <span v-else class="text--center block w-12 text-lg font-bold">{{ model?.[0] ?? 0 }}</span>
            <Slider v-model="model" class="mx-4 w-full" :range="question.params.slider_range" />
            <span v-if="question.params.slider_range" class="text--center block w-12 text-lg font-bold">
                {{ model?.[1] ?? 100 }}
            </span>
        </div>
    </div>
</template>
<style scoped></style>
